import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { ProdOrder } from './prod-order'
import { Observable } from 'rxjs'
import { ProdOrderCommand, ProdOrderCommandResult } from './commands/prod-order-command'

@Injectable({ providedIn: 'root' })
export class ProdOrderService extends RestClientPaged<ProdOrder, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/prod-orders', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Commands                                                                *
   *                                                                         *
   **************************************************************************/

  public executeCommand(cmd: ProdOrderCommand): Observable<ProdOrderCommandResult> {
    return this.http.post<ProdOrderCommandResult>(
      this.getEntityUrl(cmd.prodOrderId) + '/commands',
      cmd
    )
  }
}
